import { ProjectLinkProps } from './types'
import { CIMSPageItem, pathify } from '@cims-online/shared'
import CIMSLink from '../CIMSLink'
import { Typography } from 'antd'
import { useProjectContext } from 'context/ProjectContext'

/**
 * @see {@link CIMSLink}
 */
const ProjectLink: React.FC<ProjectLinkProps> = ({
  item,
  children,
  recordId,
  deep,
  newTab,
}) => {
  const { projectId } = useProjectContext()
  const segments = [projectId]
  /** the dev site isn't seeing items as instances of CIMSPageItem... */
  if ((item as CIMSPageItem).module) {
    const { module, pathname } = item as CIMSPageItem
    segments.push(module.pathname, pathname)
  } else segments.push(item.pathname)
  const resolvedRecordId = deep?.recordId ?? recordId
  if (resolvedRecordId) segments.push(resolvedRecordId.toString())
  let link = (
    <CIMSLink newTab={newTab} to={pathify(...segments)}>
      {children}
    </CIMSLink>
  )
  if (deep?.deleted) {
    link = (
      <Typography.Text delete={deep.deleted} style={{ cursor: 'pointer' }}>
        <CIMSLink
          newTab={newTab}
          to={{
            pathname: pathify(...segments),
            search: `?inactive=inactive`,
          }}
        >
          {children}
        </CIMSLink>
      </Typography.Text>
    )
  }
  return link
}

export default ProjectLink
